import { useEffect, useState, useContext } from "react";
import { ManifestoInterface as iData } from "../../interfaces";
import manifestoService from "../../services/ManifestoService";
import { Card, Col, Dropdown, Form, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowUp, faBarcode, faCheck, faCheckCircle, faEllipsis, faIdCard, faPaperPlane, faPencil, faPlus,
    faPrint, faQrcode, faSync, faTrash, faXmark,
    faXmarkCircle

} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import {
    JCaption, JCard, JCardBody, JPaginacao, JRow,
    JTable,
    JTBody, JTHead, PdfModal
} from "../../components/Components";
import { AuthContext } from "../../contexts/AuthContext";
import ModalIncluirCondutor from "./eventos/condutor/IncluirCondutor";
import { IncluirDFeForm } from "./eventos/DFe/IncluirDFe";
import { formatDate } from "../../utils/utils";
import { ModalListaDFe } from "./eventos/DFe/ListaDFe";
import { useModalMessage } from "../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../components/ModalQuestion/useModalQuestion";
import { useModalProcessing } from "../../components/ModalProcessing/useModalProcessing";

export default function IndexManifesto() {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const [dados, setDados] = useState<iData[]>([]);
    const [showSpinner, setShowSpinner] = useState<boolean>(true);
    const [showCondutor, setShowCondutor] = useState<boolean>(false);
    const [showIncluirDFe, setShowIncluirDFe] = useState<boolean>(false);
    const [showListaDFe, setShowListaDFe] = useState<boolean>(false);
    const [search, setSearch] = useState<string>('');
    const [meta, setMeta] = useState<any>(null)
    const [links, setLinks] = useState<any>(null)
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const [showPdf, setShowPdf] = useState<boolean>(false);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [manifesto, setManifesto] = useState<string>('');
    const [situacao, setSituacao] = useState<number>(0);
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();
    const { startProcessing, stopProcessing, ProcessingModalEl } = useModalProcessing();
    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Insert') {
            navigate('/manifesto/create');
        }
    }

    const handleStatusServico = () => {
        manifestoService.statusServico().then(res => {
            alertModal(<>{res.xMotivo}  {res.tpAmb === "2" ? " - Homologação" : ""} </>, "success");

        }).catch(error => {
            alertModal(error.response.data.message, "danger")
        });
    }

    const handleShowInclusaoCondutor = (id: string, sit: number) => {
        setManifesto(id);
        setShowCondutor(true);
        setSituacao(sit)
        setSelecionado(id)
    }

    const handleShowIncluirDFe = (id: string) => {
        setManifesto(id);
        setShowIncluirDFe(true);
        setSelecionado(id)
    }

    const handleShowListaDFe = (id: string) => {
        setManifesto(id);
        setShowListaDFe(true);
        setSelecionado(id)
    }

    const handleOpenPdf = async (id: string) => {
        await manifestoService.damdfe(id).then(res => {

            const file = new Blob([res], { type: 'application/pdf' });
            const url = URL.createObjectURL(file);

            setPdfUrl(url);
            setShowPdf(true);
            setSelecionado(id)

        }).catch(err => {
            setSelecionado('')
            alertModal('Error ao carregar DAMDF-e', 'danger');
        });
    };

    const searchFilter = (page: string | null = null) => {

        setShowSpinner(true);
        manifestoService.getAllPaginate(search, page).then(response => {
            setDados(response.data);
            setLinks(response.links);
            setMeta(response.meta);
            setShowSpinner(false);

        }).catch(err => {
            setShowSpinner(false);

        });
    }

    const handleClose = () => {
        if (pdfUrl) {
            URL.revokeObjectURL(pdfUrl);
            setPdfUrl(null);
        }
        setShowPdf(false);
        setSelecionado('')
    };

    const handleCloseModalCondutor = () => {
        setShowCondutor(false);
        setSelecionado('')
    }

    const handleCloseModalIncluirDFe = () => {
        setShowIncluirDFe(false);
        setSelecionado('')
    }

    const handleCloseModalListaDFe = () => {
        setShowListaDFe(false);
        setSelecionado('')
    }

    const handleDelete = async (data: iData) => {
        setSelecionado(data.id);
        
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{data.nmdf}</strong> ?</>,
            title: "Confirmação"           
        });
        if (confirmed) {
            startProcessing();
            await manifestoService.delete(data.id).then(() => {
                setDados(dados.filter(item => item.id !== data.id));
                stopProcessing();
            }).catch(err => {
                const error400 = [403, 400]
                if (error400.includes(err.response.status)) {
                    alertModal(err.response.data.message, "danger");
                }
                stopProcessing();
            });
        }
        setSelecionado('')
    }

    const handlePageChange = (page: string | null = null) => {
        searchFilter(page)
    }

    const handleEditarManifesto = (id: number | string) => {
        manifestoService.get(id.toString()).then(() => {
            navigate(`/manifesto/${id}`)
        }).catch(error => {
            alertModal(error.response.data.message, 'danger');
        })
    }

    const handleTransmitir = async (data: iData) => {
        setSelecionado(data.id);
        const confirmed = await confirm({
            message: <>Transmitir <strong>{data.nmdf}</strong> ?</>,
            title: "Transmissão de manifesto",
            btnConfirmOptions: {
                title: 'Sim, transmitir',
                icon: faPaperPlane,
                variant: 'success'
            }
        });
       
        if (confirmed) {
            startProcessing();
            await manifestoService.transmitir(data.id.toString()).then((res) => {
                setDados((prev) => prev.map((item) =>
                    item.id === data.id ? {
                        ...item,
                        situacao_display: res.data.situacao_display,
                        situacao: res.data.situacao,
                        chave: res.data.chave,
                        dhemi: res.data.dhemi
                    } : item)
                );
                stopProcessing();
                setSelecionado('')
            }).catch(error => {
                stopProcessing();
                setSelecionado('')
                alertModal(error.response.data.message, "danger");
            });
        }
        setSelecionado('')
    }

    const handleEncerrar = async (data: iData) => {
        const confirmed = await confirm({
            message: <>Encerrar manifesto número: <strong>{data.nmdf}</strong> ?</>,
            title: "Encerramento",
            btnConfirmOptions: {
                title: 'Sim, Encerrar',
                icon: faCheckCircle,
                variant: 'success'
            },
            
        });
        
        if (confirmed) {
            startProcessing();
            await manifestoService.encerrar(data.id.toString()).then((res) => {

                setDados((prev) => prev.map((item) =>
                    item.id === data.id ? {
                        ...item,
                        situacao: res.data.situacao,
                        situacao_display: res.data.situacao_display,
                        chave: res.data.chave,
                        dhemi: res.data.dhemi
                    } : item)
                );
                stopProcessing();
            }).catch(error => {
                stopProcessing();
                alertModal(error.response.data.message, "danger");
            })
        }
    }

    const handleCancelar = async (data: iData) => {
        const confirmed = await confirm({
            message: <>Cancelar manifesto número: <strong>{data.nmdf}</strong> ?</>,
            title: "Cancelamento",
            btnConfirmOptions: {
                title: 'Sim, Cancelar',
                icon: faCheckCircle,
                variant: 'success'
            },
        }); 
        
        if (confirmed) {
            startProcessing();
            await manifestoService.cancelar(data.id.toString()).then((res) => {
                setDados((prev) => prev.map((item) =>
                    item.id === data.id ? {
                        ...item,
                        situacao: res.data.situacao,
                        situacao_display: res.data.situacao_display,
                        chave: res.data.chave,
                        dhemi: res.data.dhemi
                    } : item)
                );
                stopProcessing();
            }).catch(error => {
                stopProcessing();
                alertModal(error.response.data.message, "danger");
            })
        }
    }

    const situacaoColor = (status: number) => {
        switch (status) {
            case 1:
                return 'btn-primary fw-bold';
            case 2:
                return 'btn-success fw-bold';
            case 3:
                return 'btn-warning fw-bold';
            case 4:
                return 'btn-danger fw-bold';
            default:
                return 'btn-primary fw-bold';
        }
    }

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        searchFilter();

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [search]);

    return (
        <>
            <JCard >
                <Card.Header className="pb-0 ps-2">
                    <JRow className="d-flex justify-center align-items-center">
                        {(authContext?.checkPermission('manifesto_create') ||
                            authContext?.userLogado.is_superuser === 1 ||
                            authContext?.userLogado.is_staff === 1) && (
                                <Col sm="auto">
                                    <Form.Group className="mb-2" controlId="descricao">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="primary"
                                                id="dropdown-basic"
                                                className="rounded no-caret rounded-circle ">
                                                <FontAwesomeIcon icon={faEllipsis} />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item as={Link} to={'/manifesto/create'}
                                                    title="Adicionar [Insert]">
                                                    <FontAwesomeIcon icon={faPlus} /> Novo manifesto
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Link} to={''} onClick={handleStatusServico} >
                                                    <div className="d-flex align-items-center">
                                                        <FontAwesomeIcon icon={faSync} className="text-success me-1 "
                                                        />
                                                        <span className="">Status do Serviço</span>
                                                    </div>
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Form.Group>
                                </Col>
                            )}

                        <Col sm="4">

                            {(authContext?.checkPermission('manifesto_search') ||
                                authContext?.userLogado.is_superuser === 1 ||
                                authContext?.userLogado.is_staff === 1) && (

                                    <Form.Group className="mb-2" controlId="descricao">
                                        <Form.Control type="search"
                                            value={search}
                                            placeholder="Procurar"
                                            aria-label="Procurar"
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </Form.Group>

                                )}
                        </Col>

                        <Col md={"auto"} className="ms-auto"  >
                            <Spinner style={{ float: 'right' }} variant="success" hidden={!showSpinner}
                                animation="border" role="status" />
                        </Col>

                    </JRow>
                </Card.Header>
                <JCardBody>
                    <JCaption title="Lista de Manifestos">
                        <JPaginacao
                            links={links ?? {}}
                            meta={meta ?? {}}
                            handlePageChange={handlePageChange} />
                    </JCaption>
                    <div className="table-responsive" style={{ overflowY: 'clip', minHeight: '15rem' }}>
                        <JTable >
                            <JTHead>
                                <tr>
                                    <th style={{ width: '2.5rem' }} className="text-center">#</th>
                                    <th style={{ width: '7rem' }}>NÚMERO</th>
                                    <th style={{ width: '11rem' }}>DT. EMISSÃO</th>
                                    <th>CHAVE DE ACESSO</th>
                                    <th className="text-center" style={{ width: '9rem' }} >MODAL</th>
                                    <th className="text-center" style={{ width: '4.5rem' }}>UF FIM</th>
                                    <th style={{ width: '13rem' }} className="text-center">
                                        SITUAÇÃO
                                    </th>
                                </tr>
                            </JTHead>
                            <JTBody>
                                {dados?.map((data) => (
                                    <tr key={data.id}
                                        className={data.id.toString() === selecionado.toString() ? 'table-success' : ''}>
                                        <td className="text-center p-0 m-0">

                                            <Dropdown className="d-grid gap-2"  >
                                                <Dropdown.Toggle id="dropdown-basic" size="sm"
                                                    variant=""
                                                    className="no-caret rounded-1 btn btn-sm">
                                                    <FontAwesomeIcon icon={faEllipsis} />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    {data.situacao !== 1 && (

                                                        <Dropdown.Item as={Link} to={``}
                                                            onClick={() => handleOpenPdf(data.id)} >
                                                            <FontAwesomeIcon
                                                                style={{ minWidth: '1.25rem' }} icon={faPrint}
                                                                className="text-primary me-1" /> DAMDF-e
                                                        </Dropdown.Item>
                                                    )}

                                                    {data.situacao === 2 && (
                                                        <>
                                                            <Dropdown.Item as={Link} to={``}
                                                                onClick={() => handleEncerrar(data)}>
                                                                <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                    icon={faCheck}
                                                                    className="text-success me-1" /> Encerrar
                                                            </Dropdown.Item>

                                                            <Dropdown.Item as={Link} to={``}
                                                                onClick={() => handleCancelar(data)}>
                                                                <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                    icon={faXmark}
                                                                    className="text-danger me-1" /> Cancelar
                                                            </Dropdown.Item>

                                                        </>
                                                    )}

                                                    {data.situacao === 1 && (
                                                        <>
                                                            <Dropdown.Item as={Link} to={``}
                                                                onClick={() => handleEditarManifesto(data.id)}>
                                                                <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                    icon={faPencil}
                                                                    className="text-primary me-1" /> Editar
                                                            </Dropdown.Item>

                                                            <Dropdown.Item as={Link} to={``}
                                                                onClick={() => handleDelete(data)}>
                                                                <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                    icon={faTrash}
                                                                    className="text-danger me-1" /> Remover
                                                            </Dropdown.Item>

                                                            <Dropdown.Item as={Link} to={``}
                                                                onClick={() => handleTransmitir(data)}>
                                                                <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                    icon={faArrowUp}
                                                                    className="text-success me-1" /> Transmitir
                                                            </Dropdown.Item>

                                                        </>
                                                    )}

                                                    {data.situacao !== 1 && data.modal === 1 && (
                                                        <Dropdown.Item as={Link} to={``}
                                                            onClick={() => {
                                                                handleShowInclusaoCondutor(data.id, data.situacao)
                                                            }}>
                                                            <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                icon={faIdCard}
                                                                className="text-primary me-2" />
                                                            {
                                                                data.situacao === 2 ?
                                                                    'Inclusão Condutor' :
                                                                    'Listagem de condutores'
                                                            }
                                                        </Dropdown.Item>
                                                    )}

                                                    {(data.situacao === 2 && data.indcarregaposterior) && (<>
                                                        <Dropdown.Item as={Link} to={``}
                                                            onClick={() => { handleShowIncluirDFe(data.id) }}>
                                                            <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                icon={faBarcode}
                                                                className="text-primary me-1" /> Incluir Chave
                                                        </Dropdown.Item>

                                                    </>)}

                                                    {(data.situacao !== 1 && data.indcarregaposterior) && (<>
                                                        <Dropdown.Item as={Link} to={``}
                                                            onClick={() => { handleShowListaDFe(data.id) }}>
                                                            <FontAwesomeIcon style={{ minWidth: '1.25rem' }}
                                                                icon={faQrcode}
                                                                className="text-success me-1" /> Lista de DF-es incluídos
                                                        </Dropdown.Item>
                                                    </>)}



                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                        <td>
                                            {data.situacao === 1 ? (<>
                                                <Link
                                                    title="Clique para editar o manifesto" to={`/manifesto/${data.id}`}
                                                    style={{ textDecoration: 'none' }}>
                                                    {data.nmdf}
                                                </Link>
                                            </>) : (<>

                                                {data.nmdf}
                                            </>)}
                                        </td>
                                        <td>{formatDate(data.dhemi, 'dd/MM/yyyy HH:mm:ss')}</td>
                                        <td>{data.chave}</td>
                                        <td className="text-center">{data.modal_display}</td>
                                        <td className="text-center">{data.uffim}</td>
                                        <td className="text-center">
                                            <span className="d-grid">
                                                <div className={
                                                    `btn btn-sm pe-none py-0  ${situacaoColor(data.situacao)}`
                                                }>
                                                    {data.situacao_display.toUpperCase()}
                                                </div>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </JTBody>
                        </JTable>
                    </div>
                </JCardBody>
            </JCard>
            <PdfModal show={showPdf} onHide={handleClose} pdfUrl={pdfUrl} />

            {showCondutor && (
                <ModalIncluirCondutor
                    show={showCondutor}
                    onHide={handleCloseModalCondutor}
                    id={manifesto}
                    situacao={situacao}

                />
            )}

            {showIncluirDFe && (
                <IncluirDFeForm id={manifesto} show={showIncluirDFe} onHide={handleCloseModalIncluirDFe} />
            )}

            {showListaDFe && (
                <ModalListaDFe id={manifesto} show={showListaDFe} onHide={handleCloseModalListaDFe} />
            )}
            {ModalMessageEl}
            {ConfirmModal}
            {ProcessingModalEl}
        </>
    );
};
